export default __webpack_public_path__ + "static/media/05.9075b2e4.jpg";